import { MutableRefObject, useEffect, useRef, useState } from 'react';

export default function useInViewport(
    threshold: number = 0,
    disconnectOnVisible: boolean = true,
    rootMargin?: string
): [MutableRefObject<HTMLElement | null>, boolean] {
    let nodeRef = useRef<HTMLElement | null>(null);
    let observerRef = useRef<IntersectionObserver | null>(null);

    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!nodeRef?.current) {
            return;
        }

        observerRef.current = new IntersectionObserver(
            (entries) => {
                setIsVisible(entries[0].isIntersecting);
            },
            { threshold, rootMargin },
        );

        observerRef.current.observe(nodeRef.current);

        return () => {
            observerRef?.current?.disconnect();
        };
    }, [threshold]);

    useEffect(() => {
        if (isVisible && disconnectOnVisible) {
            observerRef?.current?.disconnect();
        }
    }, [isVisible, disconnectOnVisible]);

    return [nodeRef, isVisible];
}
